import notification_box from "./notification-box.svg";
import notification_text_1 from "./notification-text-1.svg";
import notification_text_2 from "./notification-text-2.svg";
import notification_text_3 from "./notification-text-3.svg";
import notification_text_4 from "./notification-text-4.svg";
import notification_text from "./notification-text.svg";
import started from "./Started.svg";
import x from "./x.svg";
import check from "./check.svg";
import alert_circle from "./alert-circle.svg";
import annotation_info from "./annotation-info.svg";
import refresh_ccw from "./refresh-ccw-01.svg";
import property_1_1 from "./property_1_1.svg";
import property_1_2 from "./property_1_2.svg";
import property_1_3 from "./property_1_3.svg";
import property_1_4 from "./property_1_4.svg";
import property_1_5 from "./property_1_5.svg";
import property_1_6 from "./property_1_6.svg";
import property_1_7 from "./property_1_7.svg";
import property_1_8 from "./property_1_8.svg";
import property_1_9 from "./property_1_9.svg";
import property_1_10 from "./property_1_10.svg";
import property_1_15 from "./property_1_15.svg";
import property_1_16 from "./property_1_16.svg";
import property_1_17 from "./property_1_17.svg";

export {
  notification_box,
  notification_text_1,
  notification_text_2,
  notification_text_3,
  notification_text_4,
  notification_text,
  x,
  started,
  check,
  annotation_info,
  refresh_ccw,
  alert_circle,
  property_1_1,
  property_1_2,
  property_1_3,
  property_1_4,
  property_1_5,
  property_1_6,
  property_1_7,
  property_1_8,
  property_1_9,
  property_1_10,
  property_1_15,
  property_1_16,
  property_1_17,
};
